import LzDialog from './dialog.vue';

LzDialog.install = function(Vue) {
  Vue.component(LzDialog.name, LzDialog);
};

export default LzDialog;